import { render, staticRenderFns } from "./WidgetSetup.vue?vue&type=template&id=5be3b572&scoped=true"
import script from "./WidgetSetup.vue?vue&type=script&lang=js"
export * from "./WidgetSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be3b572",
  null
  
)

export default component.exports